import React from 'react';
import { Button } from 'semantic-ui-react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import QRCode from "react-qr-code";
import Modal from 'shared/components/Modal';
import CloseIcon from '@material-ui/icons/Close';
import messages, { FormattedMessage } from 'shared/messages/messages';

import 'semantic-ui-css/semantic.min.css';
import html2canvas from 'html2canvas';

const styles = theme => ({
    form: {
        position: 'relative',
        zIndex: 2,
        width: '100%',
        background: '#fff',
        padding: '2rem 2rem',
        margin: '4vh auto 0',
        boxShadow: '3px 3px 20px rgba(0, 0, 0, 0.5)',
        maxWidth: '350px',
        borderRadius: '10px'
    },
    formBackdrop: {
        position: 'fixed',
        zIndex: 1,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5))'
    },
    closeIcon: {
        position: 'absolute',
        top: '5px',
        right: '5px',
        color: '#949494',
        opacity: 0.5,
        cursor: 'pointer',
        '&:hover': {
            opacity: 1
        }
    },
    buttonContainer: {
        textAlign: 'center'
    }
})

class QrCodeModal extends React.Component {
    constructor(props) {
        super(props);
    }

    downloadQR() {
        html2canvas(document.getElementById('#qrContainer')).then(function (canvas) {
            var url = canvas.toDataURL('image/png');
            var link = document.createElement('a');
            link.download = 'qr_code.png';
            link.href = url;
            link.click();
        });
    }

    render() {
        const { classes, user } = this.props;

        let qrText = <FormattedMessage {...messages.consumer_qr_text} />;
        let showQr = true;
        if (user) {
            qrText = user.theme.qr_popup_message || qrText;
            showQr = !user.theme.hide_download_qr;
        }

        return (
            <Modal
                disableScrollbar={true}
                isOpen={this.props.qrDialogOpen}
                close={this.props.closeQRCodeModal.bind(this)}>
                <div className={classes.formBackdrop}></div>
                <div className={classes.form}>
                    <CloseIcon className={classes.closeIcon} onClick={this.props.closeQRCodeModal.bind(this)} />
                    <h3>
                        {qrText}
                    </h3>
                    <div id='#qrContainer' style={{ padding: '20px' }}>
                        <QRCode value={this.props.access_code} />
                    </div>
                    <br />
                    <div className={classes.buttonContainer}>
                        {
                            showQr &&
                            <Button onClick={this.downloadQR}><FormattedMessage {...messages.consumer_nav_download} /></Button>
                        }
                    </div>
                </div>
            </Modal>
        )
    }
}

const mapStateToProps = state => ({
    access_code: state.userReducer.access_code,
    user: state.userReducer.user
});

const QrCodeComponent = withStyles(styles, { withTheme: true })(QrCodeModal);
export default connect(mapStateToProps, {})(QrCodeComponent);
